/**
 * Detects whether the current device can hover (i.e. has a pointer capable
 * of producing `mousemove`/`mouseleave` without a preceding tap), rather
 * than whether it merely supports touch. Touch-capable desktops/laptops
 * (hybrid devices) can do both, so gating on touch support alone hides the
 * hover interaction entirely on those devices.
 *
 * When `window.matchMedia` is unavailable, hover capability is unknown, so
 * this defaults to `true` to avoid losing hover behaviour.
 */
export const canHover = () => {
  if (typeof window.matchMedia !== 'function') {
    return true;
  }

  return window.matchMedia('(hover: hover)').matches;
};
